<!-- component that shows activechat pet details on rightbar -->
<template>
  <div v-if="chat" class="chat-details h5 px2 py2">
    <div class="flex-none">
      <div v-if="chat.pet.imageId" class="avatar mx-auto circle" :title="chat.name" v-bind:style="{ backgroundImage: 'url(' + petImageUrl + ')'}"></div>
      <div v-else class="avatar mx-auto bg-gray-6 circle"></div>
    </div>
    <div class="flex-auto">
      <div v-if="petNickname" class="semibold">{{petNickname}}</div>
      <div v-if="chat.userName">{{chat.userName}}</div>
      <div v-if="chat.pet && chat.pet.insuranceNumber">Vakuutusnumero {{chat.pet.insuranceNumber}}</div>
    </div>
  </div>
</template>


<script>
import Util from '@/util';

export default {
    name: 'ChatDetails',
    props: {
      chat: Object,
    },
    computed: {
      petImageUrl() {
          return Util.getPetImageURL(this.chat);
      },
      petNickname() {
        return (this.chat.pet && (this.chat.pet.nickname || this.chat.pet.name)) || "";
      },
    },
};
</script>

<style scoped>
  .chat-details {
    display: flex;
    align-items: center;
  }

  .avatar {
    width: 4rem;
    height: 4rem;
    margin-right: .5rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media (min-height: 768px) {
    .chat-details {
      flex-direction: column;
      text-align: center;
      padding-bottom: 1.5rem;
    }

    .avatar {
      width: 6rem;
      height: 6rem;
      margin-right: auto;
      margin-bottom: 1rem;
    }
  }
</style>
